// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__2DhPQ","ThumbZoom":"ChapterPlayer_ThumbZoom__5UycC"};